import { newsApi } from './api';
import {
    DELETE_DRIVER_ENDPOINT,
    DRIVER_EDIT_ENDPOINT,
    DRIVER_STORE_ENDPOINT,
    EDIT_APPLICATION_ENDPOINT,
    EDIT_MODE_ENDPOINT,
    GET_DRIVER_MANAGE_ENDPOINT,
    GET_DRIVER_RECRUITMENT_ENDPOINT,
    GET_DRIVER_STATISTICS_ENDPOINT,
    GET_SELECT_DRIVER_ENDPOINT,
    RESENT_INVITE_ENDPOINT,
    STATUS2_ENDPOINT,
    STATUS_ENDPOINT,
    VIEW_DRIVER_ENDPOINT,
} from "./apiConstant";

export const DashboardService = newsApi.injectEndpoints({
    endpoints: (build) => ({
        getAppStatusStatistics: build.query({
            query: () => ({
                url: `driver/driver-status-statistics`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Dashboard'],
        }),
        getAppStatistics: build.query({
            query: () => ({
                url: `driver/application-statistics`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Dashboard'],
        }),
        getAppNotifications: build.query({
            query: () => ({
                url: `notifications`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Notify'],
        }),
        readNotification: build.mutation({
            query: (id) => ({
                url: `notifications/read/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Notify'],
        }),
        removeAllNotification: build.mutation({
            query: () => ({
                url: `notifications/delete-all`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Notify'],
        }),
        getAppliactionHistory: build.query({
            query: (id) => ({
                url: `driver/history/${id}`,
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                },
            }),
            providesTags: ['Application'],
        }),
    }),
    overrideExisting: false,
})

export const {
    useGetAppStatusStatisticsQuery,
    useGetAppStatisticsQuery,
    useGetAppNotificationsQuery,
    useReadNotificationMutation,
    useRemoveAllNotificationMutation,
    useGetAppliactionHistoryQuery,
} = DashboardService